import { Component, Input, OnInit } from '@angular/core';

export enum AlertType {
  Success = 'Success',
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
}

export enum OneTimeAlertStatus {
  Hide = 'Hide',
  Show = 'Show',
}

@Component({
  selector: 'shared-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  @Input({ required: true }) type!: AlertType;
  @Input() oneTimeOnlyKey?: string;
  @Input() oneTimeButtonText?: string;
  @Input() showClose?: boolean;
  public oneTimeStatus?: OneTimeAlertStatus;

  ngOnInit() {
    if (this.oneTimeOnlyKey) {
      // localStorage returns null if nothing stored
      this.oneTimeStatus =
        (this.getLocalStorageValue(
          this.oneTimeOnlyKey
        ) as OneTimeAlertStatus) ?? OneTimeAlertStatus.Show;
    }
  }

  private getLocalStorageValue(key: string) {
    if (!key) {
      return null;
    }
    return localStorage.getItem(key);
  }

  private setLocalStorageValue(key: string, value: string) {
    if (!key) {
      return;
    }

    localStorage.setItem(key, value);
  }

  public get alertType(): typeof AlertType {
    return AlertType;
  }

  public get oneTimeAlertStatus(): typeof OneTimeAlertStatus {
    return OneTimeAlertStatus;
  }

  public hideOnetimeAlert() {
    if (!this.oneTimeOnlyKey) {
      return;
    }

    this.oneTimeStatus = OneTimeAlertStatus.Hide;
    this.setLocalStorageValue(this.oneTimeOnlyKey, OneTimeAlertStatus.Hide);
  }
}
